import {Component, Input, OnInit} from '@angular/core';

export type Document = {
  docHref: string;
  countryName: string;
  img: string;
};

@Component({
  selector: 'app-document-countries',
  templateUrl: './document-countries.component.html',
})
export class DocumentCountriesComponent implements OnInit {
  @Input() name!: string;
  @Input() countries!: Array<Document>;

  constructor() {
  }

  ngOnInit(): void {
  }

}
